const index = () => import(/* webpackChunkName: "incentive" */ './Index');
const edit = () => import(/* webpackChunkName: "incentive" */ './Edit');

export default {
  routes: [
    //项目
    {
      path: '/incentive/v2019/index',
      name: 'incentiveV2019Index',
      component: index,
      meta:{public:true}
    },
    {
      path: '/incentive/v2019/edit/:dbid?',
      name: 'incentiveV2019Edit',
      component: edit,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/Incentive/v2019/router.js